import { getAxiosClient } from "../../axios-client";
import { AddOfferPositionRequestBody, AddOfferPositionResponse } from "./types";

const axiosClient = getAxiosClient();
export const addOfferPosition = async (body: AddOfferPositionRequestBody) => {
  return await axiosClient.ax.post<AddOfferPositionResponse>(
    "/Offers/OffersPositionAdd",
    body
  );
};
